import { render, staticRenderFns } from "./HuaxianFinanceProjectList.vue?vue&type=template&id=3441eaa2&scoped=true&"
import script from "./HuaxianFinanceProjectList.vue?vue&type=script&lang=js&"
export * from "./HuaxianFinanceProjectList.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianFinanceProjectList.vue?vue&type=style&index=0&id=3441eaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441eaa2",
  null
  
)

export default component.exports